/**
 * @generated SignedSource<<273a1efa34640512004202309d6973fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteFrame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteFrameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteFrameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41255a229b9f794a079e333791ca0c08",
    "id": null,
    "metadata": {},
    "name": "DeleteFrameMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteFrameMutation(\n  $ids: [ID]!\n) {\n  deleteFrame(ids: $ids) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "08fa06bc67a03c10fca0131aee609231";

export default node;
